import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, computed, ref, unref, PropType } from 'vue'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { message } from '@dc-platform/dc-components'
import UserSelect from '@/components/UserSelect/index'
import CosRangePicker from '@/components/CosRangePicker/index'
import ModalForm from './components/ModalForm.vue'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { downloadFileByBase64 } from '@/utils/index'
import { businessCardList, businessCardDel } from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import type { BusinessCardParams, BusinessCardListItem } from '@/typings/api/marketingManage'

const __default__ = { name: 'DcCosZbuCardManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  subdomain: {
    type: String as PropType<'fbu' | 'lbu'>,
    required: true
  },
  permission: {
    type: Object as PropType<{
      add: string
      edit: string
      del: string
      qrcode: string
    }>,
    default: () => ({}),
    required: true
  }
},
  setup(__props) {

const { clipboardRef, copiedRef } = useCopyToClipboard()

const props = __props

const tableRef = ref()
const queryForm = reactive<BusinessCardParams>({})

const columns = computed(() => [
  { title: '销售员', dataIndex: 'followerName' },
  { title: '当前关联活动', dataIndex: 'activityName' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 240, fixed: 'right' }
])
const getList = (queryForm: BusinessCardParams, callBack: (res: any) => void) => {
  businessCardList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增/编辑员工时区弹窗
const modalFormRef = ref()
const handleChange = (rows?: BusinessCardListItem) => {
  modalFormRef.value?.init(rows)
}
const handleDelete = (rows: BusinessCardListItem) => {
  Modal.delete({
    content: '删除操作无法恢复，请谨慎操作',
    onOk() {
      businessCardDel({ id: rows.id }).then(() => {
        message.success('删除成功')
        handleQueryChange('fetch')
      })
    }
  })
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref<BusinessCardListItem>()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success('复制成功')
  } else {
    message.error('该浏览器不支持自动复制!')
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/businessCard?cardId=${currentRow.value?.id}&follower=${currentRow.value?.follower}&subdomain=${props.subdomain}&lang=${qrCodeType.value}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(qrCodeRef.value.imgUrl, `${currentRow.value?.followerName}-${qrCodeType.value}`)
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[5] || (_cache[5] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosZbuCardManage"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      name: "follower",
                      label: "销售员"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserSelect), {
                          value: queryForm.follower,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.follower) = $event)),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "startTime",
                      label: "创建时间"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CosRangePicker), {
                          startTime: queryForm.createStartTime,
                          "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.createStartTime) = $event)),
                          endTime: queryForm.createEndTime,
                          "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.createEndTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "createdBy",
                      label: "创建人"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserSelect), {
                          value: queryForm.createdBy,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.createdBy) = $event)),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleChange()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, __props.permission.add]
                ])
              ]),
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 0 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (showModal('zh-CN', record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("中文二维码")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.qrcode]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (showModal('en-US', record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("英文二维码")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.qrcode]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (handleChange(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.edit]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, __props.permission.del]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "search"]),
            _createVNode(_component_a_modal, {
              visible: visible.value,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
              title: qrCodeTitle.value,
              onOk: handleOk
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: handleCopy
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制链接")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: handleOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载二维码")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(vueQr, {
                  margin: 0,
                  size: 400,
                  text: qrCodeUrl.value,
                  logoSrc: qrCodeLogoEnum[props.subdomain],
                  logoScale: 0.25,
                  logoMargin: 6,
                  correctLevel: 0,
                  ref_key: "qrCodeRef",
                  ref: qrCodeRef
                }, null, 8, ["text", "logoSrc"])
              ]),
              _: 1
            }, 8, ["visible", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ModalForm, {
      ref_key: "modalFormRef",
      ref: modalFormRef,
      onFetch: _cache[7] || (_cache[7] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})